import { useQuery } from "@tanstack/react-query";

const QUARTER_TURN = 90;
const HALF_TURN = 180;

const readPdfAspectRatio = async (pdf: Blob): Promise<number | null> => {
	const { PDFDocument } = await import("pdf-lib");
	const document = await PDFDocument.load(await pdf.arrayBuffer(), {
		ignoreEncryption: true,
	});
	const page = document.getPages()[0];
	if (!page) return null;

	const { width, height } = page.getCropBox();
	if (!width || !height) return null;

	const rotation = Math.abs(page.getRotation().angle) % HALF_TURN;
	return rotation === QUARTER_TURN ? height / width : width / height;
};

export const usePdfAspectRatio = (
	fileId: number | null,
	pdf: Blob | null,
	isPdf: boolean,
): number | null => {
	const query = useQuery({
		queryKey: ["section-spec-pdf-aspect-ratio", fileId],
		queryFn: () => (pdf ? readPdfAspectRatio(pdf) : null),
		enabled: isPdf && pdf !== null,
		staleTime: Number.POSITIVE_INFINITY,
		retry: false,
		refetchOnWindowFocus: false,
	});
	return query.data ?? null;
};
